import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_DISCOUNT_FAILURE,
  FETCH_DISCOUNT_REQUEST,
  FETCH_DISCOUNT_SUCCESS,
  DiscountActionType,
} from '../types/discountType';

export const fetchDiscountRequest = (): DiscountActionType => ({
  type: FETCH_DISCOUNT_REQUEST,
});

export const fetchDiscountSuccess = (data: any): DiscountActionType => ({
  type: FETCH_DISCOUNT_SUCCESS,
  payload: data,
});

export const fetchDiscountFailure = (error: string): DiscountActionType => ({
  type: FETCH_DISCOUNT_FAILURE,
  payload: error,
});

export const fetchDiscount = () => {
  return async (dispatch: Dispatch<DiscountActionType>) => {
    dispatch(fetchDiscountRequest());
    try {
      const request = await Service.get('/discounts');
      const data: any = request?.data?.data;
      dispatch(fetchDiscountSuccess(data));
    } catch (error: any) {
      dispatch(fetchDiscountFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch customer');
    }
  };
};
